import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9 17.5a2.253 2.253 0 0 1 2.25 2.25.75.75 0 1 0 1.5 0A2.253 2.253 0 0 1 15 17.5h6a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 21 2.5h-4.5a3.754 3.754 0 0 0-3.75 3.75v7.5a.75.75 0 1 1-1.5 0v-7.5A3.754 3.754 0 0 0 7.5 2.5H3A1.5 1.5 0 0 0 1.5 4v12A1.5 1.5 0 0 0 3 17.5z"
    }, null, -1)
  ])))
}
export default { render: render }